import type { TFunction } from 'i18next';

const PAY_FACTOR_LABEL_TO_I18N_KEY: Record<string, string> = {
  'Department/Function': 'pe.settings.rti.field.deptFunction',
  'Job Level/Grade': 'pe.settings.rti.field.jobLevelGrade',
  'Performance Rating (Most Recent)': 'pe.settings.rti.field.perfRatingMostRecent',
  'Performance Rating (Prior Year)': 'pe.settings.rti.field.perfRatingPriorYear',
  'Performance Rating (Two Years Ago)': 'pe.settings.rti.field.perfRatingTwoYearsAgo',
  'Job Code': 'pe.db.factor.JobCode',
  'Sub Function': 'pe.db.factor.SubFunction',
};

export function getPayFactorLabel(payFactorLabel: string | undefined | null, t: TFunction): string {
  if (!payFactorLabel) return '';

  const customFieldMatch = /^Custom Field (\d+)$/.exec(payFactorLabel);
  if (customFieldMatch) {
    return t('pe.settings.rti.field.customField', {
      number: customFieldMatch[1],
      defaultValue: payFactorLabel,
    });
  }

  const mappedKey = PAY_FACTOR_LABEL_TO_I18N_KEY[payFactorLabel];
  if (mappedKey) {
    return t(mappedKey, { defaultValue: payFactorLabel });
  }

  return t(`pe.db.factor.${payFactorLabel}`, { defaultValue: payFactorLabel });
}
